import { render, staticRenderFns } from "./ModalVerVideo.vue?vue&type=template&id=48b38ea0&scoped=true&"
import script from "./ModalVerVideo.vue?vue&type=script&lang=js&"
export * from "./ModalVerVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModalVerVideo.vue?vue&type=style&index=0&id=48b38ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b38ea0",
  null
  
)

export default component.exports